export const CategoryTypes = {
    NODE : 'node',
    PANEL : 'panel',
    GUIDE : 'line',
};
